import { ActionCreator, on } from '@ngrx/store';
export const CLEAR_STATE_REDUCER = <T>(stateAction: ActionCreator, state: T) =>
  on(stateAction, () => ({
    ...state
  }));
